import { MdmPolicyCommand } from "@devices/types";
import { Collapse } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import { useStyles } from "./PolicyCommandItem.style";

type Props = {
    policyCommand: MdmPolicyCommand;
    index: number;
    open: number;
};

export const PolicyCommandDetails = ({ policyCommand, index, open }: Props) => {
    const { classes } = useStyles();

    return (
        <TableRow>
            <TableCell colSpan={6} className={classes.customCollapse} style={{ paddingTop: 0, paddingBottom: 0, border: "0px" }}>
                <Collapse in={open === index} timeout="auto" unmountOnExit>
                    <div className={classes.collapsingRowContent}>
                        <br />
                        <div>
                            <pre>{JSON.stringify(policyCommand, null, 2)}</pre>
                        </div>
                    </div>
                </Collapse>
            </TableCell>
        </TableRow>
    );
};
